YUI.add('input-hint', function (Y) {

"use strict";


/* InputHint class constructor */
var InputHint = function(config) {

    InputHint.superclass.constructor.apply(this, arguments);
    try {
            config.host.on('focus', this.clear);
            config.host.on('blur', this.restore);
    } catch(e) {
            /* nothing */
    }
};

/*
 * Required NAME static field, to identify the class and
 * used as an event prefix, to generate class names etc. (set to the
 * class name in camel case).
 */
InputHint.NAME = "InputHint";

/*
 * Required NS static field, to identify the property on the host which will,
 * be used to refer to the plugin instance ( e.g. host.feature.doSomething() )
 */
InputHint.NS = "inputHint";

/*
 * The attribute configuration for the plugin. This defines the core user facing state of the plugin
 */
InputHint.ATTRS = {};

/* InputHint extends the base Plugin.Base class */
Y.extend(InputHint, Y.Plugin.Base, {

    clear: function() {
        if (this.get('value') === this.get('defaultValue')) {
            this.set('value', "");
        }

    },

    restore: function() {
        if (this.get('value')==="") {
            this.set('value', this.get('defaultValue'));
        }

    }

});

Y.namespace("Plugin").InputHint = InputHint;

}, '2.0.0', {"requires": ["node", "base", "plugin"]});

